"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HackerTooltip = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const hooks_1 = require("../hooks");
// eslint-disable-next-line react/display-name
exports.HackerTooltip = react_2.default.forwardRef((_a, ref) => {
    var props = __rest(_a, []);
    const { primaryColor } = (0, hooks_1.usePrimaryColor)();
    return (react_2.default.createElement(react_1.Tooltip, Object.assign({ ref: ref, variant: "outline", colorScheme: primaryColor, borderRadius: 0, fontWeight: "thin", bgColor: "blackAlpha.700", color: primaryColor, borderColor: primaryColor, borderWidth: "1px", openDelay: 300 }, props)));
});
//# sourceMappingURL=HackerTooltip.js.map